<!--
  CustomerSearchFilter is a reusable component that is used to search for customers.
  It reads/writes from the `search` URL query param.
-->
<script>
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import { iSearchInput } from '@inscribe/signal';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';

export default {
  components: {
    iSearchInput,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  computed: {
    value() {
      return decodeURIComponent(this.params.search || '');
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  beforeUnmount() {
    // Cleanup: Clear the debounce timer to avoid memory leaks
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  },
  methods: {
    onInputChanged(value) {
      if (value === '') {
        value = undefined;
      }
      // Note: the 'status' param is cleared when the search input is changed
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          page: 1,
          search: value,
          status: undefined,
        },
      });
    },
    clearSearch() {
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          search: undefined,
        },
      });
    },
    onInputClicked() {
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.CUSTOMERS_SEARCH_CLICKED, {
        itemName: 'search-input',
      });
    },
  },
};
</script>

<template>
  <div class="i-mb-lg i-radius-lg" @click="onInputClicked">
    <i-search-input
      id="customerSearchInput"
      data-testid="customer-search-input"
      input-placeholder="Search customers"
      :debounce-time="400"
      :filled-value="value"
      @input="onInputChanged"
    ></i-search-input>
  </div>
</template>
